import { createSharedComposable } from '@vueuse/shared';
import { useApiClient } from '@/app/core/api-client';
import { config } from '@/app/core/config';
import { AnnouncementRaw } from '../../interfaces';

export const useAnnouncementApi = createSharedComposable(() => {
  const { transport } = useApiClient();

  function bffGetAnnouncements() {
    return transport.get<AnnouncementRaw[]>('/content/app-announcements', {
      baseURL: config.bffUrl,
    });
  }

  return {
    bffGetAnnouncements,
  };
});
